import React, {useState, useEffect, useRef, useContext } from 'react';
import RightGnb from './mapModule/RightGnb'
import Slider from './mapModule/Slider'
import SearchProcess from './mapModule/SearchProcess'
import RPProcess from './mapModule/RPProcess'
import PoiInfoWindow from './mapModule/infoWindow/PoiInfoWindow'
import TbtInfoWindow from './mapModule/infoWindow/TbtInfoWindow'
import ClusterInfoWindow from './mapModule/infoWindow/ClusterInfoWindow'
import MapRightClick from './mapModule/MapRightClick'
import LabelDetect from './mapModule/LabelDetect'
import MiniMap from './mapModule/MiniMap'
import util from '../common/util';
// import grayscale from '../common/grayscale';
import { MapContext } from '_context/MapContext';
import { globalContext, LayoutContext } from '_context/LayoutContext';
import {ollehModule, loader} from '../common/mapAPIExport'

const KTMap = (props) => {
    const [init, setInit] = useState(null);
    const [currentMarker, setCurrentMarker] = useState(null);
    const [currentClusterMarker, setCurrentClusterMarker] = useState(null);
    const [signal, setSignal] = useState(null);
    const [clusterSignal, setClusterSignal] = useState(null);
    const [idleEventFire, setIdleEventFire] = useState(true);
    const [directClose, setDirectClose] = useState(false);
    const [immediateClose, setImmediateClose] = useState('');
    const infoWindowType = useRef('search');
    const [currTbtMarker, setCurrTbtMarker] = useState(null);
    const [tbtSignal, setTbtSignal] = useState(null);
    //const [mapCenter, setMapCenter] = useState(null);
    const {settingKtMapIns, routes, rpOpts} = useContext(MapContext);
    const { currentLocation } = useContext(globalContext);
    const { status } = useContext(LayoutContext);
    const mapIns = useRef(null)

    useEffect(() => {
        if(init){
            return
        }
        setInit(true)
        loader(()=>{
            let zoom = 11;
            let center = new ollehModule.maps.UTMK(958245.8, 1944235.4)
            if(window.localStorage.getItem('GIS_REMEBER_ZOOM')){
                zoom = window.localStorage.getItem('GIS_REMEBER_ZOOM')
            }
            if(window.localStorage.getItem('GIS_REMEBER_CENTER')){
                let point = JSON.parse(window.localStorage.getItem('GIS_REMEBER_CENTER'))
                if(point.x>800000 && point.x<1300000 && point.y>1300000 && point.y<2100000){
                    center.x = point.x
                    center.y = point.y
                }else{
                    zoom = 2;
                }
            }
            // eval("olleh.maps.env.TILE_URL.BASE = olleh.maps.env.TILE_URL.BASE.replace('http', 'https')")
            var mapDom = document.getElementById('mapArea')
            mapIns.current = new ollehModule.maps.Map(mapDom, {
                zoomControl: false,
                panControl: false,
                scaleControl: true,
                scaleControlOptions:{right: 12, bottom:0, position: ollehModule.maps.control.Control.BOTTOM_RIGHT, direction: ollehModule.maps.control.Control.VERTICAL},
                copyrightControl: false,
                mapTypeControl: false,
                measureControl: false,
                zoom:0,
                customTrafficInfoControl:true,
                customTrafficInfoControlOptions:{right:70, top:100},
                center: center,
                disableShadow: true
            })
            // mapIns.current.onEvent('center_changed', function (event, payload) {
            //     //setMapCenter(mapIns.current.getCenter())
            // });
            mapIns.current.setZoom(zoom)
            settingKtMapIns(mapIns.current)
            mapAddFunctionDefine()
            window.onbeforeunload = () => {
                window.localStorage.setItem('GIS_REMEBER_CENTER', JSON.stringify(mapIns.current.getCenter()));
                window.localStorage.setItem('GIS_REMEBER_ZOOM', mapIns.current.getZoom());
            }
        })
    }, [init]);

    useEffect(() => {
        setCurrentMarker(null)
    }, [routes]);

    useEffect(() => {
        setImmediateClose(util.guid())
    }, [rpOpts.rpType]);

    // useEffect(() => {
    //     setMode('poi')
    // }, [props.poiResult]);

    useEffect(() => {
        infoWindowHandler(null)
        infoWindowHandler2(null)
        if(currentLocation && mapIns.current){
            let position = util.latlngToUtmk(currentLocation.latitude, currentLocation.longitude)
            let center = mapIns.current.getCenter()
            center.x = position.x
            center.y = position.y
            mapIns.current.setCenter(center);
            if(mapIns.current.getZoom()<11){
                mapIns.current.setZoom(11);
            }
        }
    }, [currentLocation]);

    const infoWindowHandler = (marker, idle)=>{
        setDirectClose(util.guid())
        infoWindowType.current = 'thema'
        if(idle){
            setDirectClose(false)
            setIdleEventFire(false)
        }
        setCurrentMarker(marker)
        setSignal(util.guid())

        let boundTimer = setInterval(function() {
            clearInterval(boundTimer);
            setIdleEventFire(true)
        },1000);
    }

    const infoWindowHandler2 = (marker)=>{
        tbtInfoWindowHandler(null)
        setDirectClose(util.guid())
        infoWindowType.current = 'search'
        if(marker){
            setCurrentMarker(marker)
            setSignal(util.guid())
        }
        // else{
        //     setDirectClose(util.guid())
        // }
    }

    const clusterInfoWindowHandler = (clusterMarker, idle) => {
        // setCurrentClusterMarker(null)
        // setDirectClose(util.guid())
        // if(clusterMarker){
        //     setCurrentClusterMarker(clusterMarker)
        //     setClusterSignal(util.guid())
        // }
        
        infoWindowType.current = 'cluster'
        setCurrentClusterMarker(null)
        setDirectClose(util.guid())
        if(idle){
            setDirectClose(false)
            setIdleEventFire(false)
        }
        setCurrentClusterMarker(clusterMarker)
        setClusterSignal(util.guid())

        let boundTimer = setInterval(function() {
            clearInterval(boundTimer);
            setIdleEventFire(true)
        },1000);
    }

    const closeHandler = (e)=>{
        if(e && e.stopPropagation){
            e.stopPropagation()
        }
        setIdleEventFire(true)
    }

    const idleEndHandler = ()=>{
        if(infoWindowType.current==='search'){
            return
        }
        setIdleEventFire(true)
        setDirectClose(true)
        setDirectClose(false)
    }

    const tbtInfoWindowHandler = (marker)=>{
        setCurrTbtMarker(marker)
        if(marker)
            setTbtSignal(util.guid())
    }

    const tbtInfoWindowShow = (marker)=>{
        if(!marker){
            return
        }
        let position = marker.getPosition();
        let center = mapIns.current.getCenter()
        center.x = position.x
        center.y = position.y
        mapIns.current.setCenter(center);
        if(mapIns.current.getZoom()<11){
            mapIns.current.setZoom(11);
        }
        setCurrTbtMarker(marker)
        setTbtSignal(util.guid())
        props.tbtClick(null, marker.idx)
    }

    const mapAddFunctionDefine = ()=>{
        mapIns.current['grayMode'] = (mode)=>{
            let agent = navigator.userAgent.toLowerCase();
            if ( (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || (agent.indexOf("msie") !== -1) ) { // IE 일 경우
                alert('IE에서는 지원하지 않습니다.')
            }else{
                if(mode){
                    document.getElementById('root_pane').children[0].style.filter='grayscale(1)'
                    document.getElementById('root_pane').children[1].style.filter='grayscale(1)'
                    document.getElementById('root_pane').children[11].style.filter='grayscale(1)'
                }else{
                    document.getElementById('root_pane').children[0].style.filter='grayscale(0)'
                    document.getElementById('root_pane').children[1].style.filter='grayscale(0)'
                    document.getElementById('root_pane').children[11].style.filter='grayscale(0)'
                }
            }
        }
    }
    
    return (
        <div id='ktMapArea' >
            <div id='mapArea' style={{width: '100vm',height: '100vh', opacity:status==='simul'?0.3:1}}>    
            </div>
            <RightGnb infoWindow={infoWindowHandler} clusterInfoWindow={clusterInfoWindowHandler} idleEventFire={idleEventFire} idleEnd={idleEndHandler}/>
            <Slider/>
            <SearchProcess poiClick={props.poiClick}  infoWindow={infoWindowHandler2}/>
            <RPProcess tbtClick={props.tbtClick} infoWindow={tbtInfoWindowHandler} tbtInfoWindowShow={tbtInfoWindowShow} infoWindow2={infoWindowHandler2}/>
            <PoiInfoWindow marker={currentMarker} signal={signal} close={closeHandler} directClose={directClose}/>
            <ClusterInfoWindow marker={currentClusterMarker} signal={clusterSignal} close={closeHandler} directClose={directClose}/>
            <TbtInfoWindow marker={currTbtMarker} signal={tbtSignal} close={closeHandler} immediateClose={immediateClose} nextClick={tbtInfoWindowShow} prevClick={tbtInfoWindowShow}/>
            <MapRightClick thisPointAddressHandler={props.thisPointAddressHandler} thisPointResearchHandler={props.thisPointResearchHandler}/>
            <LabelDetect infoWindow={infoWindowHandler} />
            <MiniMap/>
        </div>
    );
}

export default KTMap;